// extracted by mini-css-extract-plugin
module.exports = {"snowWebcams":"styles_snowWebcams__tqL7c","title":"styles_title__jmhUO","wrapperBox":"styles_wrapperBox__aC2t4"};